import cx from "classnames"
import React from "react"
import { RatingIcons, RatingIconsPropsType } from "./RatingIcons"
import { RatingInput } from "./RatingInput"
import { RatingCompact, formatRatingValue } from "./RatingCompact"
import RatingLabel from "./RatingLabel"

type RatingPropsType = RatingIconsPropsType & {
  children?: React.ReactNode
  iconsClassName?: RatingIconsPropsType["className"]
}

function Rating({
  className,
  iconsClassName,
  children,
  ...iconsProps
}: RatingPropsType) {
  return (
    <div className={cx("cobalt-rating", className)}>
      <RatingIcons className={iconsClassName} {...iconsProps} />
      {children}
    </div>
  )
}

export {
  Rating,
  RatingLabel,
  RatingInput,
  RatingCompact,
  RatingIcons,
  formatRatingValue,
}
